import { guardianCharas } from '@/mocks/characters';

export default function CharaShowcase() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="text-center">
        <span className="inline-flex items-center gap-2 text-sm font-semibold text-accent-600">
          <i className="ri-heart-3-line" aria-hidden="true"></i>
          守护甜心图鉴
        </span>
        <h2 className="mt-3 font-heading text-2xl font-black text-foreground-900 md:text-3xl">
          会孵化的伙伴 · 守护甜心一览
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-foreground-600">
          每一位守护甜心，都对应着主人内心深处某个真实而珍贵的一面。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {guardianCharas.map((ch) => (
          <article
            key={ch.id}
            className="flex flex-col items-center rounded-2xl border border-background-200/80 bg-background-50 p-4 text-center transition-colors hover:border-accent-300"
          >
            <div className="flex h-24 w-24 items-center justify-center overflow-hidden rounded-full bg-background-100 md:h-28 md:w-28">
              <img
                src={ch.image}
                alt={`守护甜心 ${ch.name}（${ch.owner}）`}
                className="h-full w-full object-cover"
                loading="lazy"
              />
            </div>
            <h3 className="mt-3 font-heading text-base font-bold text-foreground-900">{ch.name}</h3>
            <span className="mt-1 rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-medium text-primary-700">
              {ch.trait} · {ch.owner}
            </span>
            <p className="mt-2 hidden text-xs leading-5 text-foreground-600 sm:block">{ch.desc}</p>
          </article>
        ))}
      </div>
    </section>
  );
}